(function() {
  define('tlhServicesArray',['angular'], function() {
    'use strict';
    return angular.module('tlhServicesArray', []).factory('TlhArrayService', [
      function() {
        var factory, isActiveElement;
        factory = {};
        factory.getFirstActiveElement = function(elements) {
          var element, firstActiveElement, _i, _len;
          firstActiveElement = null;
          for (_i = 0, _len = elements.length; _i < _len; _i++) {
            element = elements[_i];
            if (element.isActive) {
              firstActiveElement = element;
              break;
            }
          }
          return firstActiveElement;
        };
        factory.getLastActiveElement = function(elements) {
          var element, lastActiveElement, _i, _len;
          lastActiveElement = null;
          for (_i = 0, _len = elements.length; _i < _len; _i++) {
            element = elements[_i];
            if (element.isActive) {
              lastActiveElement = element;
            }
          }
          return lastActiveElement;
        };
        factory.hasActiveElements = function(elements) {
          return factory.getNbActiveElements(elements) > 0;
        };
        factory.getNbActiveElements = function(elements) {
          return factory.getActiveElements(elements).length;
        };
        factory.getActiveElements = function(elements) {
          if (elements == null) {
            elements = [];
          }
          return elements.filter(isActiveElement);
        };
        isActiveElement = function(element) {
          return element.isActive;
        };
        return factory;
      }
    ]);
  });

}).call(this);

//# sourceMappingURL=array.js.map
;
